<template>
  <v-row>
    <v-col
      cols="12"
      lg="7"
      xl="6"
      class="channel d-none d-md-flex align-center justify-center"
    >
      <v-container>
        <div class="pa-10">
          <v-row justify="center">
            <v-col cols="8" xl="5">
              <div>
                <h2 class="display-1 white--text font-weight-medium">
                  <img src="../../assets/images/onseminar-logo.png" />
                </h2>
                <h6
                  class="subtitle-1 mt-4 white--text op-5 font-weight-regular"
                >
                  One-stop platform service that goes well with everyone,
                  anytime, anywhere :)
                </h6>
                <!-- <v-btn
                  class="mt-4 text-capitalize"
                  x-large
                  outlined
                  color="white"
                  >Learn More</v-btn
                > -->
              </div>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-col>
    <v-col cols="12" lg="5" xl="6" class="d-flex align-center">
      <v-container>
        <div class="pa-7 pa-sm-12">
          <v-row>
            <v-col cols="12" lg="9" xl="6">
              <h2 class="font-weight-bold mt-4 blue-grey--text text--darken-2">
                Sign in
              </h2>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="E-mail"
                  color="channel"
                  class="mt-4"
                  required
                  outlined
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  :counter="14"
                  :rules="passwordRules"
                  label="Password"
                  color="channel"
                  required
                  outlined
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                  @keypress.enter="delay"
                  @keypress.enter.prevent
                ></v-text-field>

                <div class="d-block d-sm-flex align-center mb-4 mb-sm-0">
                  <div class="ml-auto">
                    <!-- <a class="link" @click.stop="forgotDialog = true"
                      >Forgot pwd?</a
                    > -->
                    <v-btn
                      text
                      @click.stop="openForgotDialog()"
                      class="mb-3 text-caption"
                      >Forgot Password ?</v-btn
                    >
                  </div>
                </div>

                <v-btn
                  :disabled="!valid"
                  color="channel"
                  block
                  class="mr-4 white--text"
                  @click="delay"
                  >Sign In</v-btn
                >
              </v-form>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-col>
    <!-- 비밀번호 찾기 모달창 -->
    <v-dialog v-model="forgotDialog" max-width="400">
      <v-card>
        <div class="d-flex pa-2 align-center primary">
          <v-card-title class="headline white--text"
            >Forgot Password
          </v-card-title>
          <div class="ml-auto">
            <v-btn icon @click="closeForgotDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-card-text class="mt-7">
          <v-card-text class="pa-0"
            >No Worries. Just tell us the email address you registered with
            Onseminar.</v-card-text
          >
          <v-form ref="form2" v-model="valid" lazy-validation>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="forgotEmail"
                  :rules="emailRules"
                  label="E-mail"
                  prepend-icon="mdi-email"
                  color="primary"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="d-flex justify-end">
                <vue-recaptcha
                  sitekey="6LecSmUaAAAAAMQQ4dXr1LfLIKHx4qLgSf45rtVG"
                  :loadRecaptchaScript="true"
                ></vue-recaptcha
              ></v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="mr-2 white--text" @click="send()"
            >Send</v-btn
          >
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click="closeForgotDialog()"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import store from "../../store";
import VueRecaptcha from "vue-recaptcha";

export default {
  components: { VueRecaptcha },
  name: "SignIn",
  data: () => ({
    valid: true,
    password: "",
    show1: false,
    forgotDialog: false,
    forgotEmail: "",
    passwordRules: [
      v => !!v || "Password is required",
      v => (v && v.length <= 14) || "Password must be less than 14 characters"
    ],
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    checkbox: false
  }),

  methods: {
    async delay() {
      if (this.valid) {
        this.valid = false;
        // Re-enable after 5 seconds
        this.timeout = setTimeout(() => {
          this.valid = true;
        }, 2500);
        await this.submit();
      }
    },
    async submit() {
      this.$refs.form.validate();
      if (this.$refs.form.validate(true)) {
        try {
          await store.dispatch("signIn", {
            email: this.email,
            password: this.password,
            redirect: this.$route.query.redirect
          });
        } catch (e) {
          console.log("[SignIn] error", e);
        }
      }
    },
    async send() {
      this.$refs.form2.validate();
      console.log("1");
      // eslint-disable-next-line no-undef
      var v = grecaptcha.getResponse();
      // console.log(v);
      if (v.length == 0) {
        this.$notify({
          type: "warning",
          title: "Please Check [I'm not a robot]",
          duration: 5000,
          closeOnClick: true
        });
        return false;
      }

      const path = "/auth/forgot-password?email=" + this.forgotEmail;
      try {
        console.log(this.$axiosAuthNoToken);
        const data = await this.$axiosAuthNoToken.get(path);
        console.log("4");
        console.log({ data });
        if (data && data.status == 200) {
          this.$notify({
            type: "success",
            title: "Forgot Password",
            text:
              "An email has been sent to change the password. Please check your email.",
            duration: 5000,
            closeOnClick: true
          });
        }
      } catch (e) {
        const msg = e.response.data.message;
        this.$notify({
          type: "error",
          title: "Forgot Password",
          text: msg,
          duration: 5000,
          closeOnClick: true
        });
      }
      this.closeForgotDialog();
    },
    openForgotDialog() {
      this.forgotDialog = true;
      if (this.email) {
        this.forgotEmail = this.email;
      }
    },
    closeForgotDialog() {
      this.$refs.form2.reset();
      this.$refs.form2.resetValidation();
      this.forgotDialog = false;
    }
  },
  async beforeCreate() {
    // 경로에 리다이렉트가 없을 경우
    console.log(this.$route.query.redirect);
    if (!this.$route.query.redirect) {
      this.$router.push({ name: "Channel" });
    }

    // 로그인된 유저가 로그인페이지에 접근시
    const user = await this.$Auth.currentAuthenticatedUser().catch(() => {});
    if (user) {
      // console.log("222");
      this.$router.push({ name: "Channel" });
    }
  },
  beforeDestroy() {
    // clear the timeout before the component is destroyed
    clearTimeout(this.timeout);
  }
};
</script>
